import API from "./API";

export default class NaturezaTrabalhos extends API
{
    static async all() {
        return this.get("api/admin/natureza-trabalhos");
    }

}
